export const PRODUCT_VARIANTS_FEATURE = 'productVariants';
